import { render, staticRenderFns } from "./LatestMetricsAlertRuleStrategy.global.vue?vue&type=template&id=15cd148b&lang=pug&"
import script from "./LatestMetricsAlertRuleStrategy.global.vue?vue&type=script&lang=ts&"
export * from "./LatestMetricsAlertRuleStrategy.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports